import type { Organizer } from '@/types';
import styles from './AvatarComponent.module.scss';
import { CrownIcon } from '@/components/_shared/Icons';
import { UserIcon } from '../../UserIcon/UserIcon';
import { Avatar } from '@eventbrite/marmalade';
import { getImageProps } from 'next/image';

export interface AvatarComponentProps {
  organizer: Organizer;
  size?: 'small' | 'large';
  variant?: 'default' | 'organizer-info';
}

export const AvatarComponent: React.FC<AvatarComponentProps> = ({ organizer, size = 'large', variant = 'default' }) => {
  const avatarText = (organizer.name && organizer.name[0]) || '';

  const baseClasses = [styles.avatarContainer];
  if (variant === 'organizer-info') {
    baseClasses.push(styles.avatarWithBadge);
  }
  baseClasses.push(styles[size]);

  const className = baseClasses.join(' ').trim();

  const {
    props: { src },
  } = getImageProps({
    alt: '',
    width: 52,
    height: 58,
    src: organizer.image || '',
  });

  const isSuperOrganizer = organizer.superOrganizer === true;

  return (
    <div className={className}>
      <Avatar
        className={styles.customAvatar}
        text={avatarText}
        icon={<UserIcon />}
        imageSrc={src}
        imageAlt={organizer.name}
        placeholder={organizer.name}
      ></Avatar>
      {isSuperOrganizer && (
        <div className={styles.badge}>
          <CrownIcon />
        </div>
      )}
    </div>
  );
};
